import { render, staticRenderFns } from "./CustomerEditTabRelated.vue?vue&type=template&id=739851b0"
import script from "./CustomerEditTabRelated.vue?vue&type=script&lang=js"
export * from "./CustomerEditTabRelated.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditTabRelated.vue?vue&type=style&index=0&id=739851b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports